<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import autoScroll from "embla-carousel-auto-scroll";

	const { messages }: { messages: string[] } = $props();
</script>

<Carousel
	class="bg-fcrdarkgray pointer-events-none"
	items={messages}
	options={{ loop: true, align: "start" }}
	plugins={[autoScroll({ speed: 0.75 })]}
>
	{#snippet item(message)}
		<div class="text-base/10 px-40 !max-w-[unset] font-semibold text-nowrap shrink-0 text-white">
			{message}
		</div>
	{/snippet}
</Carousel>
